import React from 'react';

import MockParliment2025 from 'views/MockParliment2025';

const MobileAppPage = () => {
  return <MockParliment2025 />;
};

export default MobileAppPage;
